export const SET_PUBLIC_DSR_DISPLAY = 'set_public_dsr_display';

export const GET_PUBLIC_DSR_CONFIG_REQUEST = 'get_public_dsr_config_request';
export const GET_PUBLIC_DSR_CONFIG_SUCCESS = 'get_public_dsr_config_success';
export const GET_PUBLIC_DSR_CONFIG_FAILURE = 'get_public_dsr_config_failure';

export const JOIN_PUBLIC_DSR_REQUEST = 'join_public_dsr_request';
export const JOIN_PUBLIC_DSR_SUCCESS = 'join_public_dsr_success';
export const JOIN_PUBLIC_DSR_FAILURE = 'join_public_dsr_failure';
export const JOIN_PUBLIC_DSR_RESET = 'join_public_dsr_reset';